export default "__VITE_ASSET__D9iwXRq1__"